import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CmsBannerCarouselPeekComponent } from '@promo/const';
import { DeviceService } from '@shared/services';
import { CmsService } from '@spartacus/core';
import { BREAKPOINT, CmsComponentData } from '@spartacus/storefront';
import { Observable, filter, map } from 'rxjs';
import { SwiperOptions } from 'swiper/types';
import { SdBannerCarouselComponent } from '../banner-carousel/banner-carousel.component';

@Component({
  selector: 'sd-banner-carousel-peek',
  templateUrl: 'banner-carousel-peek.component.html',
  styleUrls: ['./banner-carousel-peek.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SdBannerCarouselPeekComponent extends SdBannerCarouselComponent implements OnInit {
  sizes = this.deviceService.sizes;

  defaultConfig: SwiperOptions = {
    slidesPerView: 5,
    breakpoints: {
      [this.sizes.sm]: {
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 10,
      },
      [this.sizes.md]: {
        slidesPerView: 4,
        slidesPerGroup: 4,
        spaceBetween: 10,
      },
      [this.sizes.lg]: {
        slidesPerView: 6,
        slidesPerGroup: 6,
        spaceBetween: 10,
      },
    },
  };
  config$: Observable<SwiperOptions>;
  isMobile$: Observable<boolean> = this.deviceService.isMobileSmDown$;
  componentData$: Observable<CmsBannerCarouselPeekComponent>;
  widthOneSlideOnMobile$: Observable<string>;

  private countOfSlidesOnMobile$: Observable<number>;

  constructor(
    private deviceService: DeviceService,
    protected componentData: CmsComponentData<CmsBannerCarouselPeekComponent>,
    cmsService: CmsService,
  ) {
    super(componentData, cmsService);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.componentData$ = this.componentData.data$.pipe(
      filter(Boolean),
      map((data) => this.normalizeComponentData(data)),
    );

    this.countOfSlidesOnMobile$ = this.componentData$.pipe(
      map((componentData) => Number(componentData.mobileDisplayBannersCount) || 2),
    );

    this.widthOneSlideOnMobile$ = this.countOfSlidesOnMobile$.pipe(
      // необходимо чтобы отображалось count + 1/3 слайдов. 15px - gap между слайдами, 24px - padding контейнера страницы
      map((count) => `calc(((100vw - 24px) / (${count} + 1/3)) - 15px)`),
    );

    this.config$ = this.componentData$.pipe(
      map((componentData) => {
        // prettier-ignore
        const slideCountMapping: Record<BREAKPOINT, number> = {
          [BREAKPOINT.xxs]: Number(componentData.mobileDisplayBannersCount || componentData.tabletDisplayBannersCount) || 2,
          [BREAKPOINT.xs]: Number(componentData.mobileDisplayBannersCount || componentData.tabletDisplayBannersCount) || 2,
          [BREAKPOINT.sm]: Number(componentData.mobileDisplayBannersCount || componentData.tabletDisplayBannersCount) || 2,
          [BREAKPOINT.md]: Number(componentData.tabletDisplayBannersCount || componentData.mobileDisplayBannersCount) || 4,
          [BREAKPOINT.lg]: Number(componentData.normalDisplayBannersCount || componentData.tabletDisplayBannersCount) || 6,
          [BREAKPOINT.xl]: Number(componentData.widescreenDisplayBannersCount || componentData.normalDisplayBannersCount) || 6,
          [BREAKPOINT.xxl]: Number(componentData.widescreenDisplayBannersCount || componentData.normalDisplayBannersCount) || 6,
        };

        return {
          ...this.defaultConfig,
          breakpoints: {
            [0]: {
              slidesPerView: slideCountMapping[BREAKPOINT.xs],
              slidesPerGroup: slideCountMapping[BREAKPOINT.xs],
              spaceBetween: 10,
            },
            [this.sizes.sm]: {
              slidesPerView: slideCountMapping[BREAKPOINT.sm],
              slidesPerGroup: slideCountMapping[BREAKPOINT.sm],
              spaceBetween: 10,
            },
            [this.sizes.md]: {
              slidesPerView: slideCountMapping[BREAKPOINT.md],
              slidesPerGroup: slideCountMapping[BREAKPOINT.md],
              spaceBetween: 10,
            },
            [this.sizes.lg]: {
              slidesPerView: slideCountMapping[BREAKPOINT.lg],
              slidesPerGroup: slideCountMapping[BREAKPOINT.lg],
              spaceBetween: 10,
            },
            [1200]: {
              slidesPerView: slideCountMapping[BREAKPOINT.xl],
              slidesPerGroup: slideCountMapping[BREAKPOINT.xl],
              spaceBetween: 10,
            },
          },
        };
      }),
    );
  }

  private normalizeComponentData(componentdata: CmsBannerCarouselPeekComponent): any {
    return {
      ...componentdata,
      // убираем все не цифры из строки
      mobileDisplayBannersCount: Number(componentdata.mobileDisplayBannersCount.replace(/\D/g, '')),
      tabletDisplayBannersCount: Number(componentdata.tabletDisplayBannersCount.replace(/\D/g, '')),
      normalDisplayBannersCount: Number(componentdata.normalDisplayBannersCount.replace(/\D/g, '')),
      widescreenDisplayBannersCount: Number(componentdata.widescreenDisplayBannersCount.replace(/\D/g, '')),
    };
  }
}
